import { buildGenericOfferSaleTermsText, OFFER_SALE_TERMS_ROUTE } from '../../constants/offer-sale-terms';
import { EUROASIANN_GROUP_NAME } from '../../constants/euroasiann-branding';

export function OfferSaleTermsPage() {
  const termsText = buildGenericOfferSaleTermsText();

  return (
    <div className="min-h-screen w-full bg-[hsl(var(--background))] text-[hsl(var(--foreground))]">
      <header className="relative w-full border-b border-[hsl(var(--border))] bg-[hsl(var(--card))] px-4 py-4 shadow-sm sm:px-6 lg:px-8">
        <div className="flex w-full flex-col items-center justify-center text-center">
          <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#0088cc]">
            {EUROASIANN_GROUP_NAME}
          </p>
          <h1 className="text-xl font-bold text-[hsl(var(--foreground))] sm:text-2xl">
            Offer Terms and Conditions of Sale
          </h1>
        </div>
        <a
          href="/login"
          className="absolute right-4 top-1/2 -translate-y-1/2 text-xs font-semibold text-[#0088cc] hover:text-[#0077b3] sm:right-6 lg:right-8"
        >
          Admin Login
        </a>
      </header>

      <main className="w-full px-4 py-6 sm:px-6 lg:px-8">
        <div className="w-full rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-4 shadow-sm sm:p-6 lg:p-8">
          <p className="mb-6 text-center text-sm text-[hsl(var(--muted-foreground))]">
            Marine spare parts · Complete sale terms ·{' '}
            <span className="font-mono text-xs">{OFFER_SALE_TERMS_ROUTE}</span>
          </p>
          <pre className="w-full whitespace-pre-wrap text-justify font-sans text-[14px] leading-relaxed text-[hsl(var(--foreground))]">
            {termsText}
          </pre>
        </div>
      </main>
    </div>
  );
}

export default OfferSaleTermsPage;
